import { Box, Grid, Typography } from "@mui/material";

import { AppFormType } from "components/Forms/AppForm";

import { FileMetadata } from "../ProductForm.schema";

interface FileUploadSectionProps {
  productForm: AppFormType | { AppField: any; state: { values: any } };
}

//TODO: we could probably consolidate the file upload section and the ear required section as a single file upload component
const FileUploadSection = ({ productForm }: FileUploadSectionProps) => {
  const options = {
    attachmentType: [
      { value: "Security Target", label: "Security Target" },
      { value: "Sync Meeting Notes", label: "Sync Meeting Notes" },
      { value: "Product Information", label: "Product Information" },
      { value: "Remote Testing Requests", label: "Remote Testing Requests" },
      { value: "Other Documents", label: "Other Documents" },
    ],
    documentVisibility: [
      { value: "Public", label: "Public" },
      { value: "Proprietary", label: "Proprietary" },
    ],
  };

  //TODO: I need to figure out the console warning here for controlled vs uncontrolled components

  return (
    <Box className="mb-4">
      <Typography variant="body1" className="mb-2">
        FILE UPLOADS
      </Typography>
      <div className="border p-3 rounded">
        <Typography
          variant="body1"
          className="mb-3"
          sx={{ color: "text.secondary" }}
        >
          Upload the files for the product.{" "}
          <span className="fst-italic fw-bold">
            NOTE: Security Target upload is required to submit this form
          </span>
        </Typography>

        <Grid container spacing={3} sx={{ mb: 2 }}>
          <Grid item xs={12} md={4}>
            <productForm.AppField name="fileType">
              {(field: any) => (
                <field.SelectField
                  options={options.attachmentType}
                  label="Document Type"
                  data-cy="Document Type"
                  onChange={(val: string) => {
                    //@ts-ignore
                    productForm.setFieldValue("fileLabel", val);
                  }}
                />
              )}
            </productForm.AppField>
          </Grid>
          <Grid item xs={12} md={4}>
            <productForm.AppField name="documentVisibility">
              {(field: any) => (
                <field.SelectField
                  options={options.documentVisibility}
                  label="Document Visibility"
                  data-cy="Document Visibility"
                />
              )}
            </productForm.AppField>
          </Grid>
          <Grid item xs={12} md={4}>
            <productForm.AppField name="fileLabel">
              {(field: any) => <field.TextInput label="File Label" />}
            </productForm.AppField>
          </Grid>
        </Grid>

        <productForm.AppField name="files" data-cy="file-upload">
          {(field: any) => (
            <field.FileUpload
              disabled={false}
              label="Choose File"
              annotateFile={(file: File) => {
                //@ts-ignore
                const { getFieldValue } = productForm;
                const fileType = getFieldValue("fileType");
                const documentVisibility = getFieldValue("documentVisibility");
                const fileLabel = getFieldValue("fileLabel");
                // we want to set the fileName as the file.name
                const fileName = file.name;
                const active = true;

                return {
                  fileType,
                  documentVisibility,
                  fileLabel,
                  fileName,
                  active,
                };
              }}
            />
          )}
        </productForm.AppField>

        <Box
          flex="1 1 100%"
          display="flex"
          gap={2}
          flexWrap="wrap"
          className="mt-3"
        >
          <productForm.AppField name="files">
            {(field: any) =>
              field.state.value
                .filter((file: FileMetadata) => file.active)
                .map((file: FileMetadata, index: number) => {
                  return (
                    <field.FileCard
                      file={file.file || file}
                      title={file.fileLabel || file.fileType}
                      subheader={file.documentVisibility}
                      fileName={file.fileName}
                      index={index}
                      key={`${file.file_id || file.fileName}-${index}`}
                    />
                  );
                })
            }
          </productForm.AppField>
        </Box>
      </div>
    </Box>
  );
};

export default FileUploadSection;
